import { useState, useEffect } from 'react'
import Board from '../board/board.component'
import DeviceInfoCard from '../device-info-card/device-info-card.component'
import DeviceMainCard from '../device-main-card/device-main-card.component'
import './device-map.styles.css'
import axios from 'axios'

import Grid from '../../assets/images/grid-icon.png'
import lamp from '../../assets/images/lamp.png'
import generator from '../../assets/images/generator-icon.png'
import pv from '../../assets/images/pv-icon.png'
import idle from '../../assets/images/battery.png'
import ev from '../../assets/images/ev-icon.png'


import gridMiniIcon from "../../assets/images/grid-icon.png";
import evMiniIcon from "../../assets/images/mini-icon/ev-icon.png";
import lampMiniIcon from '../../assets/images/mini-icon/lamp-icon.png';
import generatorMiniIcon from '../../assets/images/mini-icon/generator-icon.png';
import pvMiniIcon from '../../assets/images/mini-icon/pv-icon.svg';
import batteryMiniIcon from "../../assets/images/mini-icon/Battery.png";

const DeviceMap = ({ handleLastUpdate, startDate, endDate }) => {
  const [idleTitle, setIdleTitle] = useState(null)
  const [loadSw, setloadSw] = useState(null)
  const [clpValue, setClpValue] = useState(null)
  const [genSw, setgenSw] = useState(null)
  const [pvSw, setpvSw] = useState(null)
  const [evSw, setevSw] = useState(null)
  const [gridP, setgridP] = useState(null)
  const [gridSw, setgridSw] = useState(null)
  const [evp, setevp] = useState(null)
  const [battSw, setbattSw] = useState(null)
  const [genP, setgenP] = useState(null)
  const [batSoc, setbatSoc] = useState(null)
  const [loadP, setloadP] = useState(null)
  const [pvp, setpvp] = useState(null)
  const [vo1, setvo1] = useState(null)
  const [vo2, setvo2] = useState(null)
  const [pow, setpow] = useState(null)

  const [loading, setLoading] = useState(true) // متغیر لودینگ

  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {
        const data = JSON.stringify({
          serial_number: process.env.REACT_APP_DEVICE_ID,
          name: 'TempE', // نام موردنظر
          from: startDate.toISOString().split('T')[0], // تاریخ شروع
          to: endDate.toISOString().split('T')[0], // تاریخ پایان
        })

        const config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: process.env.REACT_APP_API_URL + '/api/last-send-data-device',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        }

        const response = await axios.request(config)

        if (response.data?.data?.last_date) {
          const lastDate = response.data.data.last_date

          // مقدار BattStatus
          const battStatus = lastDate.find((item) => item.name === 'BattStatus')
          if (battStatus) {
            setIdleTitle(battStatus.value)
          } else {
            setIdleTitle('');
          }

          // مقدار LoadSW
          const loadSwStatus = lastDate.find((item) => item.name === 'LoadSW')
          if (loadSwStatus) {
            setloadSw(loadSwStatus.value === '1' ? 'true' : 'false')
          }

          // مقدار CLP
          const clpStatus = lastDate.find((item) => item.name === 'CLP')
          if (clpStatus) {
            setClpValue(parseFloat(clpStatus.value))
          }

          // مقدار GenSW
          const genSwStatus = lastDate.find((item) => item.name === 'GenSW')
          if (genSwStatus) {
            setgenSw(genSwStatus.value === '1' ? 'true' : 'false')
          }

          // مقدار PVSW
          const pvSwStatus = lastDate.find((item) => item.name === 'PVSW')
          if (pvSwStatus) {
            setpvSw(pvSwStatus.value === '1' ? 'true' : 'false')
          }

          // مقدار EVSW
          const evSwStatus = lastDate.find((item) => item.name === 'EVSW')
          if (evSwStatus) {
            setevSw(evSwStatus.value === '1' ? 'true' : 'false')
          }

          // مقدار GridSW
          const gridSwStatus = lastDate.find((item) => item.name === 'GridSW')
          if (gridSwStatus) {
            setgridSw(gridSwStatus.value === '1' ? 'true' : 'false')
          }

          // مقدار BattSW
          const battSwStatus = lastDate.find((item) => item.name === 'BattSW')
          if (battSwStatus) {
            setbattSw(battSwStatus.value === '1' ? 'true' : 'false')
          }

          // مقدار GridP
          const gridPStatus = lastDate.find((item) => item.name === 'GridP')
          if (gridPStatus) {
            setgridP(parseFloat(gridPStatus.value))
          }

          // مقدار EVP
          const evpStatus = lastDate.find((item) => item.name === 'EVP')
          if (evpStatus) {
            setevp(parseFloat(evpStatus.value))
          }

          // مقدار GenP
          const genPStatus = lastDate.find((item) => item.name === 'GenP')
          if (genPStatus) {
            setgenP(parseFloat(genPStatus.value))
          }

          // مقدار BATSOC
          const batSocStatus = lastDate.find((item) => item.name === 'BATSOC')
          if (batSocStatus) {
            setbatSoc(parseFloat(batSocStatus.value))
          }

          // مقدار LoadP
          const loadPStatus = lastDate.find((item) => item.name === 'LoadP')
          if (loadPStatus) {
            setloadP(parseFloat(loadPStatus.value))
          }

          // مقدار PVP
          const pvpStatus = lastDate.find((item) => item.name === 'PVP')
          if (pvpStatus) {
            setpvp(parseFloat(pvpStatus.value))
          }

          // مقدار VO1
          const vo1Status = lastDate.find((item) => item.name === 'VO1')
          if (vo1Status) {
            setvo1(parseFloat(vo1Status.value))
          }

          // مقدار VO2
          const vo2Status = lastDate.find((item) => item.name === 'VO2')
          if (vo2Status) {
            setvo2(parseFloat(vo2Status.value))
          }

          // مقدار POWER
          const powerValue = lastDate.find((item) => item.name === 'POWER1')
          if (powerValue) {
            setpow(parseFloat(powerValue.value))
          }

          if (response.data?.data?.last_updated_at) {
            handleLastUpdate(response.data.data.last_updated_at);
          }
        }
      } catch (error) {
        console.error('Error fetching device data:', error)
      } finally {
        setLoading(false)
      }
    }

    // اجرای درخواست اولیه و تنظیم تایمر
    fetchDeviceData()

    const interval = setInterval(() => {
      fetchDeviceData()
    }, 60000)

    // پاکسازی تایمر هنگام خروج
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    axios.post(process.env.REACT_APP_API_URL + '/api/last-device-value-status', {
      serial_number: process.env.REACT_APP_DEVICE_ID,
    })
      .then(response => {
        setStatuses(response.data.data.device);
      })
      .catch(() => {
        console.log('Error loading statuses!');
      })
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f8f9fa',
        }}
      >
        <div
          style={{
            width: '50px',
            height: '50px',
            border: '5px solid #f3f3f3',
            borderTop: '5px solid #45A03C',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <style>
          {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
        </style>
      </div>
    )
  }

  const deviceItemData = [
    {
      id: 1,
      icon: Grid,
      className: 'grid-card',
      title: 'Grid',
      info: gridP ? `${gridP} W` : '',
      state: gridSw,
      boardClass: 'grid-board',
      miniIcon: gridMiniIcon,
    },
    {
      id: 2,
      icon: ev,
      className: 'ev-card',
      title: 'EV',
      info: evp ? `${evp} W` : '',
      state: evSw,
      boardClass: 'ev-board',
      miniIcon: evMiniIcon,
    },
    {
      id: 3,
      icon: lamp,
      className: 'ac-load-card',
      title: 'AC load',
      info: loadP ? `${loadP} W` : '',
      state: loadSw, // مقدار پویا برای LoadSW
      exteraText1: `V1:${vo1} v`,
      exteraText2: `V2:${vo2} v`,
      boardClass: 'ac-board',
      miniIcon: lampMiniIcon,
    },
    {
      id: 4,
      icon: lamp,
      className: 'critical-card',
      title: 'Critical load',
      info: clpValue ? `${clpValue} W` : '',
      state: 'true',
      exteraText1: `V1:${vo1} v`,
      exteraText2: `V2:${vo2} v`,
      boardClass: 'critical-board',
      miniIcon: lampMiniIcon,
    },
    {
      id: 5,
      icon: generator,
      className: 'generator-card',
      title: 'Generator',
      info: genP ? `${genP} W` : '',
      state: genSw,
      boardClass: 'generator-board',
      miniIcon: generatorMiniIcon,
    },
    {
      id: 6,
      icon: pv,
      className: 'pv-card',
      title: 'PV',
      info: pvp ? `${pvp} W` : '',
      state: pvSw,
      boardClass: 'pv-board',
      miniIcon: pvMiniIcon,
    },
    {
      id: 7,
      icon: idle,
      className: 'idle-card',
      title: idleTitle ? idleTitle : '', // استفاده از مقدار پویا
      info: batSoc ? `${batSoc} %` : '',
      state: battSw,
      boardClass: 'idle-board',
      exteraText1: `P:${pow} W`,
      miniIcon: batteryMiniIcon,
    },
  ]

  let deviceItems = [];

  statuses.map(status => {
    let found = false;

    deviceItemData.map(item => {
      if (item.title && item.title.toLowerCase() === status.name.toLowerCase() && status.status === 'on') {
        found = item;

        return null;
      } else if (item.id == 7 && item.title == '' && status.name.toLowerCase() == 'charging' && status.status === 'on') {
        found = item;

        return null;
      }
    });

    if (found !== false) {
      deviceItems.push(found);
    }
  });

  return (
    <div className='device-map-wrapper'>
      <DeviceMainCard cat={deviceItems} />
      {deviceItems.map((item) => (
        <DeviceInfoCard key={item.id} cat={item} />
      ))}
      {deviceItems.map((item) => (
        <Board key={item.id} cat={item} />
      ))}
    </div>
  )
}

export default DeviceMap
